<script setup>
const code = defineModel({type: String, default: ''});

defineProps({
  errors: {
    required: false,
    type: Array,
    default: () => ([]),
  },
});

const emit = defineEmits(['submit']);

/**
 * Password managers fill this field from a content script and some of them
 * dispatch a synthetic Enter afterwards to "fill and submit" — those events
 * carry isTrusted: false, so they are ignored here. Listening on keydown rather
 * than keyup also stops the stray keyup that leaks through when Enter is used
 * to pick an entry from the manager's own dropdown: the dropdown swallows the
 * keydown, but the keyup lands on the field once it has been filled.
 */
const handleEnter = (event) => {
  if (!event.isTrusted) {
    return;
  }

  emit('submit');
}
</script>

<template>
  <div class="d-flex justify-content-center align-items-center flex-column my-4">
    <input
      v-model="code"
      type="text"
      required
      class="form-control w-75"
      :class="{error: errors.length > 0}"
      placeholder="Enter Authentication Code"
      autocomplete="off"
      @keydown.enter.prevent="handleEnter"
    >

    <div
      v-if="errors.length > 0"
      class="text-danger w-75"
    >
      <small
        v-for="(error, index) in errors"
        :key="index"
      >
        {{ error }}<br>
      </small>
    </div>
  </div>

  <p class="text-center xs-mt-5 text-info">
    If you are unable to use your authentication code,<br> enter one of your recovery codes in the field above.
  </p>
</template>

<style scoped>
.form-control {
  text-align: center;
}

.text-info {
  color: #00c6dd;
}
</style>
